
import messages from '../services/messages'

import {
  getFavoriteMessages,
  setFavoriteMessages,
  favoriteMessagesError,
} from '../redux/favoriteMessages/actions'

import {
  getGeneralInfo,
  setGeneralInfo,
  generalInfoError,
} from '../redux/generalInformation/actions'

import {
  getInsights,
  setInsights,
  insightsError,
} from '../redux/insights/actions'

import { objLength } from './customMethods'

const updateInsights = (chatId, response, dispatch) => {
  const data = response?.data?.data[0]?.conversationInsights
  const obj = {
    chatId,
    data,
  }
  dispatch(setInsights(obj))
}

const updateFavoriteMsgs = (chatId, response, dispatch) => {
  const data = response?.data?.data[0]?.favoriteMessagesInformation?.messages
  const obj = {
    chatId,
    data,
  }
  dispatch(setFavoriteMessages(obj))
}

const updateGeneralInfo = (chatId, response, dispatch) => {
  const conversationInfo = response?.data?.data[0]?.conversationInformation
  const consumerInfo = response?.data?.data[0]?.consumerInformation
  const { transferHistory, extraInfo, ...chatInfo } = conversationInfo
  const data = {
    chatInfo,
    consumerInfo,
    transferHistory,
    extraInfo,
  }

  if (objLength(data) > 0) {
    const obj = {
      chatId,
      data,
    }
    dispatch(setGeneralInfo(obj))
    return obj.data
  }
}

const getChatInfo = async (chatId, dispatch) => {
  if (chatId) {
    dispatch(getInsights({}))
    dispatch(getFavoriteMessages({}))
    dispatch(getGeneralInfo({}))
    try {
      const response = await messages.get(
        `/tech4h-messages/conversation/info?id=${chatId}`,
        {
          headers: { apiVersion: '3' },
        }
      )

      if (response.status === 200) {
        updateInsights(chatId, response, dispatch)
        updateFavoriteMsgs(chatId, response, dispatch)
        return updateGeneralInfo(chatId, response, dispatch)
      } else {
        throw response.data
      }
    } catch (error) {
      console.log(error)
      const message =
        error?.response?.status === 500
          ? 'Unavailable service'
          : error?.response?.data?.message

      dispatch(insightsError({ action: 'get_insights', message: message }))
      dispatch(
        favoriteMessagesError({
          action: 'get_favorite_messages',
          message: message,
        })
      )
      dispatch(
        generalInfoError({ action: 'get_general_info', message: message })
      )
    }
  }
}

// Exports
export { updateFavoriteMsgs, updateInsights, updateGeneralInfo, getChatInfo }
